<template>
  <div class="d-flex justify-content-center text-primary">
    <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
  </div>
</template>
